import { theme } from '@aloft/toolkit-sui';

import { useEffect, useRef } from 'react';

import { selectHoveredCostApproachPropertyId } from '../../redux/features/selectors/referenceBarUISelectors.ts';
import { selectFocusedCostApproachPropertyId } from '../../redux/features/selectors/uiSelectors.ts';
import { useAppSelector } from '../../redux/hooks.ts';

const scrollHighlightedSectionIntoView = (element: HTMLElement) => {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
};

export const useCostApproachSliderAlertHighlight = (propertyId: string) => {
  const focusedPropertyId = useAppSelector(selectFocusedCostApproachPropertyId);
  const hoveredPropertyId = useAppSelector(selectHoveredCostApproachPropertyId);
  const containerRef = useRef<HTMLDivElement>(null);

  const isHighlighted =
    focusedPropertyId === propertyId || hoveredPropertyId === propertyId;

  useEffect(() => {
    if (!isHighlighted || !containerRef.current) {
      return;
    }
    scrollHighlightedSectionIntoView(containerRef.current);
  }, [isHighlighted, propertyId]);

  const highlightSx = isHighlighted
    ? {
        backgroundColor: theme.colors.alertErrorLight,
        border: `2px solid ${theme.colors.alertError}`,
        borderRadius: '4px',
      }
    : undefined;

  return { containerRef, isHighlighted, highlightSx };
};
